export const campaignConfig = {
    campaignListConfig: 'campaign_devapp', // campaign_devapp
    campaignPrivilege: 'campaign_tbank_new_privilege',
};

export const dashboardConfig = {
    mainDashboard: '',
};

export const categoryConfig = {
    menuCategory: 'menu_devapp',
    menuPrivilege: 'menu_tbank',
};

export const historyConfig = {
    purchase: 'purchase',
};

export const couponConfig = {
    coupon: 'coupon_config',
};

export const googleMapKey = {
    googleKey: 'AIzaSyCgi5rBThtti0qdKu14G5Cr8FTfr43HjEA',
    // googleKey: 'AIzaSyBXk_L_sF-3r-76xsk666MZRDPTuI2mPpU'
};
